import * as Yup from 'yup';
import { t } from 'src/lib/language';

const RecurringValidator = (lang: string, hasProductAmount = false) => Yup.object().shape({
  title: Yup.string().required(t(lang, 'validations.contact.field_required')),
  amount: hasProductAmount
    ? Yup.number().nullable()
    : Yup.number()
      .min(0.01, t(lang, 'validations.contact.field_required'))
      .required(t(lang, 'validations.contact.field_required')),
  frequency: Yup.string().nullable(),
  start_date: Yup.string().required(t(lang, 'validations.contact.field_required')),
  end_date: Yup.string().nullable(),
  contact_id: Yup.number()
    .min(1, t(lang, 'validations.contact.field_required'))
    .required(t(lang, 'validations.contact.field_required')),
});

export default RecurringValidator;
